import { Locale } from '../constants/languages';

type FormatOptions = {
  value: number;
  locale: string;
  currency: string;
};

type formatNumericValueParams = {
  value: number;
  discount?: number;
  currencyFormat: string;
};

const format = ({ value, locale, currency }: FormatOptions): string => {
  let formattedValue = new Intl.NumberFormat(locale, {
    style : 'currency',
    currency : currency,
    currencyDisplay : 'symbol'
  }).format(value);

  // UYU is the only currency that uses the $ symbol this is needed to change it to $U
  if (currency === 'UYU') {
    formattedValue = formattedValue.replace('$', '$U');
  }

  return formattedValue;
};

const formatNumericValue = ({ value, discount = 0, currencyFormat }: formatNumericValueParams): string => {
  // Extract and format the locale once, clearly
  const locale = Locale[currencyFormat as keyof typeof Locale];
  const formattedLocale = `${locale.split('_')[0]}-${locale
    .split('_')[1]
    .toUpperCase()}`;

  // Calculate the applied discount
  const appliedDiscount = value - (value * discount) / 100;

  // Format the value with the applied discount
  const formattedValue = format({
    value : appliedDiscount,
    locale : formattedLocale,
    currency : currencyFormat,
  });

  return formattedValue;
};

export default formatNumericValue;
